import type { ReferencePrompt } from '@/app/types';
import { getReferenceVideoMaxCount, isReferenceVideoPrompt } from './reference-model-capabilities';

/**
 * 判断是否为图片类型参考（包含上传的图片和图片类型的主体）
 */
export const isImageReference = (ref: ReferencePrompt): boolean => {
  if (ref.type === 'image') return true;
  if (ref.type === 'element') {
    const modality = ref.prompt?.modality;
    return modality === 'image' || !modality;
  }
  return false;
};

/**
 * 判断是否为视频类型参考（包含上传的视频和视频类型的主体）
 * @deprecated 直接用 `isReferenceVideoPrompt`，这里只是旧调用点的兼容壳。
 */
export const isVideoReference = (ref: ReferencePrompt): boolean => {
  return isReferenceVideoPrompt(ref);
};

/**
 * 判断是否为文字类型主体
 */
export const isTextElementReference = (ref: ReferencePrompt): boolean => {
  return ref.type === 'element' && ref.prompt?.modality === 'text';
};

/**
 * 获取图片和图片主体的总数
 */
export const getImageAndImageElementCount = (referencePrompts: ReferencePrompt[]): number => {
  return referencePrompts.filter(isImageReference).length;
};

/**
 * 获取视频和视频主体的总数
 */
export const getVideoAndVideoElementCount = (referencePrompts: ReferencePrompt[]): number => {
  return referencePrompts.filter(isVideoReference).length;
};

/**
 * 获取指定版本下允许选择的最大视频主体数量。
 *
 * 具体额度由 `reference-model-capabilities.ts` 的 capability table 决定，不要在这里重复描述规则。
 * @deprecated 直接用 `getReferenceVideoMaxCount`，这里只是旧调用点的兼容壳。
 */
export const getMaxVideoCount = (modelVersion: string | undefined, referencePrompts: ReferencePrompt[]): number => {
  return getReferenceVideoMaxCount(modelVersion, referencePrompts);
};

/**
 * 获取文字主体的总数
 */
export const getTextElementCount = (referencePrompts: ReferencePrompt[]): number => {
  return referencePrompts.filter(isTextElementReference).length;
};
